import Param from '../../param';

const param = new Param();

export default class fryingpanTab {
  constructor(param) {
    this.tabContainer = document.querySelectorAll('.js__tab-container');
    this.tabTrigger
    this.tabContent
    this.target = 0;
  }
  init() {
    let _tabLength = this.tabContainer.length;
    for(var i = 0 ; i < _tabLength ; i++){
        let _trigger = this.tabContainer[i].querySelectorAll('.js__tab-multi');
        let _content = this.tabContainer[i].querySelectorAll('.js__tab-content');
        let _triggerLength = _trigger.length;
        TweenMax.set(_content,{
          display:'none',
          opacity:0
        });
        TweenMax.set(_content[0],{
          display:'block',
          opacity:1
        });
        for(var o = 0 ; o < _triggerLength ; o++){
          let _index = o;
          _trigger[o].onclick = () => {
              this.target = _index;
              this.tabTrigger = _trigger;
              this.tabContent = _content;
              this.change();
              this.active();
          };
        }
    }
  }
  change(){
    TweenMax.to(this.tabContent, 0.3 ,{
      alpha: 0,
      ease : Power2.easeOut,
      onComplete:() => {
          TweenMax.set(this.tabContent, {
              display: 'none',
          });
          TweenMax.set(this.tabContent[this.target], {
              display: 'block',
              onComplete:() => {
                  TweenMax.to(this.tabContent, 0.3 , {
                      alpha: 1,
                      ease : Power2.easeIn,
                      onComplete: function(){
                          if(param.browserType === 'IE'){
                              let event = document.createEvent('Event');
                              event.initEvent('resize', true, true);
                              window.dispatchEvent(event);
                          }else {
                              window.dispatchEvent(new Event('resize'));
                          }
                      },
                  });
              }
          });
        }
    });
  }
  active() {
    let _length = this.tabTrigger.length;
    for(var i = 0 ; i < _length ; i++) {
        this.tabTrigger[i].classList.remove('is-active');
    }
    this.tabTrigger[this.target].classList.add('is-active');
  }

  render(_y, _h) {}
  resize(_w, _h, _display) {}
}
